import styled from 'styled-components'

const StyledDashboard = styled.div`
  hr {
    background-color: ${({ theme }) => theme.colors.gray[200]};
    height: 1px;
    border: 0;
    margin: 40px 0;
  }
`

export default StyledDashboard
